import {
  getCalendarInfo,
  getDashboardInfo,
  getNews,
} from '@/api/dashboard';

import {
  GET_CALENDAR_INFO,
  GET_DASHBOARD_INFO,
  GET_NEWS,
  GET_NEWS_DONE,
  GETTING_NEWS,
} from './constants';

export default {
  async [GET_CALENDAR_INFO](ctx, data) {
    const res = await getCalendarInfo(data);
    return res;
  },
  async [GET_DASHBOARD_INFO]() {
    const res = await getDashboardInfo();
    return res;
  },
  async [GET_NEWS]({ commit }) {
    commit(GETTING_NEWS, true);
    try {
      const res = await getNews();
      commit(GET_NEWS_DONE, res);
    } catch {
      commit(GET_NEWS_DONE, []);
    } finally {
      commit(GETTING_NEWS, false);
    }
  },
};
